module.exports = "https://cdn-skillquest.mathletics.com/app/186/assets/images/36ceabb42185d78ef4a1c5e91d499200.svg";